import { useState, useEffect, useRef } from "react";
import useI18n from "../../../app/providers/useI18n";
import languages from "../../../core/utils/languages/languages.json";
import "./language-selector.css";
import { capitalize } from "../../../core/utils/helpers";

const LanguageSelector = () => {
  const { changeLanguage } = useI18n();

  const containerRef = useRef(null);

  const [selectedLanguage, setSelectedLanguage] = useState({
    flag: "flag-en.png",
    label: "english",
    lang: "en",
  });

  const [isOpenLanguages, setIsOpenLanguages] = useState(false);

  // Fermer en cliquant à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpenLanguages(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={isOpenLanguages ? "l-s-container is-open" : "l-s-container"}
    >
      <div className="l-s-current-language">
        <div
          className="l-s-pairs"
          onClick={() => setIsOpenLanguages(!isOpenLanguages)}
        >
          <img
            src={process.env.PUBLIC_URL + `/flags/${selectedLanguage.flag}`}
            alt="current language"
          />

          <span>{selectedLanguage.label}</span>
        </div>
      </div>

      <div className="l-s-languages">
        {languages.map((lng) => (
          <div
            key={lng.lang}
            className={
              lng.lang === selectedLanguage.lang
                ? "l-s-pairs is-current"
                : "l-s-pairs"
            }
            onClick={() => {
              changeLanguage(lng.lang);

              setSelectedLanguage({
                flag: lng.flag,

                label: capitalize(lng.label),

                lang: lng.lang,
              });

              setIsOpenLanguages(false);
            }}
          >
            <img
              src={process.env.PUBLIC_URL + `/flags/${lng.flag}`}
              alt={lng.label}
            />

            <span>{capitalize(lng.label)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;
